import { Image } from "./image";
import React from "react";
import { FaCheckCircle } from 'react-icons/fa';
import { IoLeaf } from "react-icons/io5";
import { FaGraduationCap } from "react-icons/fa6";
import { IoIosTime } from "react-icons/io";
import { LuSearchCheck } from "react-icons/lu";
import NewCard from "./new_card";
import { FaTools } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { FaHandshakeSimple } from "react-icons/fa6";
import { FaPhone } from "react-icons/fa6";
import { TfiRulerAlt2 } from "react-icons/tfi";
import { IoIosConstruct } from "react-icons/io";
import batiment from './../construction3.png'
const engagements = [
  {
    icon: <img src={batiment} style={{width:'27px',marginBottom:'5px'}} />,
    title: "Travaux conformes et durables",
    description: "Nous réalisons chaque projet dans le respect des normes en vigueur, en garantissant solidité, sécurité et durabilité.",
  },
  {
    icon: <IoIosConstruct size={30} />,
    title: "Qualité artisanale",
    description: "Tous nos chantiers sont menés par une équipe qualifiée, polyvalente et soucieuse du détail. Chaque finition compte.",
  },
  {
    icon: <TfiRulerAlt2 size={25} />,
    title: "Solutions sur mesure",
    description: "Nous adaptons nos prestations à vos contraintes, à vos goûts et à la nature de votre espace (logement, commerce, bureau…).",
  },
  {
    icon: <FaCalendarAlt size={24} />,
    title: "Respect des délais",
    description: "Nous planifions avec rigueur et tenons nos engagements pour une exécution fluide, sans surprise.",
  },
  {
    icon: <FaHandshakeSimple size={30} />,
    title: "Accompagnement de A à Z",
    description: "Vous bénéficiez d’un interlocuteur unique pour coordonner l’ensemble des corps de métier, du début à la réception.",
  },
  {
    icon: <FaPhone  size={22} />,
    title: "Réactivité & transparence",
    description: "Une équipe à votre écoute, disponible rapidement et avec une communication claire.",
  },
];


export const Gallery = (props) => {
  return (
    <div id="Engagements" className="text-center">
      <div className="container">
        <div className="section-title">
          <br/>
          <h2>Nos Engagements</h2>
        </div>
        <div className="row">
        {engagements.map((e, index) => (
          <div className="col-sm-6 col-md-4" key={index} >

<NewCard
icon={e.icon}
          title={e.title}
          description={e.description}
       />

          </div>
        ))}
      </div>
      </div>
    </div>
  );
};
